import { z } from 'zod';
/** Media constants shared by client and server. See ADR-0005. */
export const MediaKindSchema = z.enum(['image', 'video', 'audio', 'file']);
export const MediaStateSchema = z.enum([
    'uploading',
    'processing', // queued for or running through ffmpeg
    'ready',
    'failed',
    'expired', // swept by retention; thumbnail survives (ADR-0006)
]);
/**
 * Client-side compression targets. Tuned to land near WhatsApp's output size
 * while staying encodable on a ~5-year-old phone.
 */
export const IMAGE = {
    maxEdge: 1600,
    webpQuality: 0.72,
    jpegQuality: 0.75,
    thumbEdge: 320,
    thumbQuality: 0.6,
};
export const AUDIO = {
    mimeCandidates: ['audio/webm;codecs=opus', 'audio/ogg;codecs=opus', 'audio/webm'],
    bitsPerSecond: 24000,
    maxSeconds: 300,
};
export const VIDEO = {
    maxSeconds: 60,
    maxInputBytes: 100 * 1024 * 1024,
    targetHeight: 720,
    crf: 30,
};
/** Chunked, resumable upload — mobile data drops mid-upload constantly. */
export const UPLOAD_CHUNK_BYTES = 512 * 1024;
export const UploadInitSchema = z.object({
    kind: MediaKindSchema,
    mime: z.string().max(100),
    bytes: z.number().int().positive(),
    sha256: z.string().regex(/^[0-9a-f]{64}$/),
    width: z.number().int().positive().optional(),
    height: z.number().int().positive().optional(),
    durationMs: z.number().int().positive().optional(),
});
export const UploadInitResponseSchema = z.object({
    mediaId: z.string(),
    /** True when the hash already exists: deduplicated, skip the upload entirely. */
    alreadyExists: z.boolean(),
    chunkBytes: z.number().int().positive(),
    receivedBytes: z.number().int().nonnegative(),
});
/**
 * MVP upload response: single-shot, not chunked/resumable. `UploadInitSchema`
 * above is kept for the future resumable version (tracked in an issue, not
 * built yet) — this is deliberately a separate, simpler shape so the MVP
 * response doesn't imply chunking support that doesn't exist.
 */
export const MediaUploadResponseSchema = z.object({
    mediaId: z.string(),
    alreadyExists: z.boolean(),
    bytes: z.number().int().nonnegative(),
});
//# sourceMappingURL=media.js.map